import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { DistrictSelector } from "../districtManipulation/districtSelector";
import { IDistrict } from "../districtManipulation/iDistrict";
import  { DistrictEditorView } from "./districtEditor-view"

export class DistrictEditorViewModel extends ViewModel implements IDistrict,IPopup{
    constructor(parentViewModel: ViewModel,updater : IServerUpdater) {
        super(parentViewModel);
        this._updater = updater;
        this.districtSelector = new DistrictSelector(this);
        this.districtSelector.onSelectionChanged = x=>{
            this.parentId = x.id;
            this.parentName = x.title;
        };

    }

    GetDefaultView(): View <ViewModel> {
        return new DistrictEditorView();
    }
    public getTypeId(): string {
        return "VM-7E2C7AAB-D911-48E5-B391-52CC19DC6BB0"
    }


    closePopup(result: any) {
    }
    
    cloneTo(district: IDistrict) {
        district.id = this.id;
        district.name = this.name;
        district.parentId = this.districtSelector.selectedItem?.id;
        district.parentName = this.districtSelector.selectedItem?.title
    };
    private _updater:IServerUpdater;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set parentId(v: string) { 
        this._parentId = v; 
        this.districtSelector.selectById(v);
    } public get parentId(): string { return this._parentId;} private _parentId: string;
    public set parentName(v: string) { this._parentName = v; } public get parentName(): string { return this._parentName;} private _parentName: string;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector;} private _districtSelector: DistrictSelector;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    back(){
        this.closePopup(null);
    }
    async save(){
        let verificationResult = this.verify();
        if(verificationResult.length>0){
            this.messageBoxConfirmWarning(verificationResult.join('\n'),'خطا در ثبت شعبه');
            return;
        }else{
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess('شعبه با موفقیت ثبت شد.','ثبت موفق');
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت شعبه','خطا در عملیات');
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify():string[]{
        let result :string[] = [];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام شعبه مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.parentId)){
            result.push('شعبه پدر مشخص نشده است.')
        }
        return result;
    }
}

export interface IServerUpdater{
    execute(district:IDistrict):Promise<any>;
}

export class DistrictInserter implements IServerUpdater{
    async execute(district: IDistrict): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/DistrictManipulationServices/CreateDistrict',{
                Name:district.name,
                ParentDistrictId:district.parentId
            });
            if(result.IsSuccessful==false){
                throw "Error Saving District";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

export class DistrictUpdater implements IServerUpdater{
    async execute(district: IDistrict): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/DistrictManipulationServices/CreateDistrict',{
                Name:district.name,
                ParentDistrictId:district.parentId
            });
            if(result.IsSuccessful==false){
                throw "Error Saving District";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

